export default "__VITE_ASSET__CeKgseUv__"